<div class="nav-bar">
    <div class="back" (click)="goBack()">
        <img src="assets/arrow-back.svg" alt="Back" class="back-arrow" />
    </div>
    <h1 class="title">{{ title ?? '' }}</h1>
</div>
